import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'journals'

export const journalService = {
	...getController<Api.Journal, Api.JournalPostInput, Api.JournalPostInput>(
		url
	),

	review: ({ id, data }: { id: number; data: HpRequestOptional }) =>
		Service.post({ url: `${url}/${id}/review`, data }),
}

export default journalService
